export default {
  computed: {
    now() {
      // Find nearest time slot in the future
      const now = {}
      const timestamp = this.$moment().add(30, 'minutes')

      now.time = timestamp.format('H') * 2 + 1
      now.time = timestamp.format('m') >= 30 ? now.time + 1 : now.time

      now.date = {
        id: timestamp.format('E'),
        h: timestamp.format('DD/MM/YYYY'), // human-readable
        t: timestamp.format('YYMMDD'), // technical
        day: timestamp.format('dddd'), // day name
        m: timestamp // moment value
      }

      return {
        time: this.$helpers.timeBits.find((b) => b.id === now.time),
        date: now.date
      }
    }
  }
}
